(function  pvTryBoot() {

    if (!window.matchMedia('(max-width: 767px)').matches) {
    return;
  }
 
  var DEBUG = true;
  function log() { if (DEBUG) console.log.apply(console, ['[pv]'].concat([].slice.call(arguments))); }

  function normalize(v) {
    if (!v) return null;
    var m = String(v).match(/(\d{6,})(?!.*\d{6,})/);
    return m ? m[1] : null;
  }

  var ATTRS = ['data-media-id', 'data-image-id', 'data-id', 'data-index', 'id', 'href', 'data-thumb'];

  function keyOf(el) {
    if (!el) return null;
    for (var i = 0; i < ATTRS.length; i++) {
      var k = normalize(el.getAttribute(ATTRS[i]));
      if (k) return k;
    }
    var nodes = el.querySelectorAll('[' + ATTRS.join('],[') + ']');
    for (var j = 0; j < nodes.length; j++) {
      for (var a = 0; a < ATTRS.length; a++) {
        var k2 = normalize(nodes[j].getAttribute(ATTRS[a]));
        if (k2) return k2;
      }
    }
    return null;
  }

  // Transforme une URL de vignette Shopify en URL grande taille
  function bigify(url) {
    if (!url) return null;
    if (url.indexOf('//') === 0) url = 'https:' + url;
    var parts = url.split('?');
    var path = parts[0];
    var q = parts[1] ? '?' + parts[1] : '';
    path = path.replace(/_(\d+)?x(\d+)?(_crop_[a-z]+)?(@\dx)?(?=\.[a-zA-Z]{3,4}$)/, '');
    path = path.replace(/(\.[a-zA-Z]{3,4})$/, '_1200x$1');
    return path + q;
  }

  function boot() {
    var nav = document.querySelector('.productView-nav');
    if (!nav) return;

    var slides = [].slice.call(nav.querySelectorAll('.productView-image'))
                   .filter(function (s) { return !s.classList.contains('slick-cloned'); });
    var thumbs = [].slice.call(document.querySelectorAll('.productView-thumbnail'))
                   .filter(function (t) { return !t.classList.contains('slick-cloned'); });
    if (!slides.length) return;

    var slideKeys = slides.map(keyOf);
    var thumbKeys = thumbs.map(keyOf);
    var usable = slideKeys.filter(Boolean).length === slides.length
              && thumbKeys.some(function (k) { return slideKeys.indexOf(k) !== -1; });
    log('slides', slides.length, '| thumbs', thumbs.length, '| clé', usable ? 'OK' : 'NON');

    var isSlick = nav.classList.contains('slick-initialized');
    if (!isSlick) nav.classList.add('pv-fallback');

    function thumbFor(i) {
      if (usable) {
        for (var n = 0; n < thumbs.length; n++) {
          if (thumbKeys[n] === slideKeys[i]) return thumbs[n];
        }
      }
      return thumbs[i] || null;
    }

    // Étape 1 : réveiller le lazyload du thème
    function wake(slide) {
      if (!slide) return;
      [].forEach.call(slide.querySelectorAll('source'), function (s) {
        var ds = s.getAttribute('data-srcset') || s.getAttribute('data-src');
        if (ds) s.srcset = ds;
      });
      [].forEach.call(slide.querySelectorAll('img'), function (img) {
        var ds = img.getAttribute('data-src') || img.getAttribute('data-original')
              || img.getAttribute('data-lazy') || img.getAttribute('data-image');
        var ss = img.getAttribute('data-srcset');
        if (ss) img.srcset = ss;
        if (ds && img.getAttribute('src') !== ds) img.src = ds;
        img.classList.remove('lazyload', 'lazyloading');
        img.classList.add('lazyloaded');
        img.removeAttribute('loading');
        img.style.setProperty('opacity', '1', 'important');
        img.style.setProperty('visibility', 'visible', 'important');
      });
    }

    // Étape 2 : si toujours vide, on reconstruit depuis la vignette
    function force(i) {
      var slide = slides[i];
      if (!slide) return;
      var img = slide.querySelector('img');
      if (!img) return;
      if (img.naturalWidth > 10) return; // déjà chargée, on ne touche pas

      var t = thumbFor(i);
      var timg = t && t.querySelector('img');
      var src = timg && (timg.currentSrc || timg.getAttribute('src') || timg.getAttribute('data-src'));
      var big = bigify(src);
      if (!big) { log('slide', i, ': pas d\'URL vignette'); return; }

      // Les <source> d'un <picture> écrasent le src de l'<img> : on les supprime
      var pic = img.parentNode && img.parentNode.tagName === 'PICTURE' ? img.parentNode : null;
      if (pic) [].forEach.call(pic.querySelectorAll('source'), function (s) { s.parentNode.removeChild(s); });
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = big;
      img.style.setProperty('opacity', '1', 'important');
      log('slide', i, 'reconstruit →', big.slice(-55));
    }

    var current = 0;

    function go(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      current = i;
      log('go →', i);

      if (isSlick) {
        try { jQuery(nav).slick('slickGoTo', i); } catch (e) {}
      } else {
        slides.forEach(function (s, n) {
          var on = (n === i);
          s.classList.toggle('is-active', on);
          s.style.setProperty('display', on ? 'block' : 'none', 'important');
          s.style.setProperty('opacity', on ? '1' : '0', 'important');
        });
      }

      wake(slides[i]);
      wake(slides[(i + 1) % slides.length]);
      setTimeout(function () { force(i); }, 200);
      setTimeout(function () { force(i); }, 900); // 2e passe si le réseau traîne

      [].forEach.call(document.querySelectorAll('.productView-thumbnail'), function (t) {
        var match = usable ? (keyOf(t) === slideKeys[i]) : (thumbs.indexOf(t) === i);
        t.classList.toggle('is-active', match);
      });
    }

    document.addEventListener('click', function (e) {
      var hit = e.target.closest && e.target.closest('.productView-thumbnail, .productView-thumbnail-link');
      if (!hit) return;
      var thumb = hit.closest('.productView-thumbnail') || hit;
      var i = -1;
      if (usable) i = slideKeys.indexOf(keyOf(thumb));
      if (i === -1) i = thumbs.indexOf(thumb);
      if (i === -1 || i >= slides.length) return;
      e.preventDefault();
      e.stopPropagation();
      go(i);
    }, true);

    if (!isSlick) {
      var wrap = document.querySelector('.productView-image-wrapper') || nav.parentNode;
      wrap.style.position = 'relative';
      ['prev', 'next'].forEach(function (dir) {
        if (wrap.querySelector('.pv-fb-arrow.' + dir)) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pv-fb-arrow ' + dir;
        b.setAttribute('aria-label', dir === 'prev' ? 'Image précédente' : 'Image suivante');
        b.innerHTML = dir === 'prev' ? '&#8249;' : '&#8250;';
        b.addEventListener('click', function () { go(dir === 'prev' ? current - 1 : current + 1); });
        wrap.appendChild(b);
      });

      var x0 = null;
      nav.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      nav.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(dx < 0 ? current + 1 : current - 1);
        x0 = null;
      }, { passive: true });
    }

    go(0);
  }

  window.addEventListener('load', function () { setTimeout(boot, 600); });

   var n = document.querySelector('.productView-nav');
console.log('slick:', n.classList.contains('slick-initialized'), '| fallback:', n.classList.contains('pv-fallback'));
console.log('slides:', n.querySelectorAll('.productView-image').length, '| thumbs:', document.querySelectorAll('.productView-thumbnail').length);
console.log('script exceute premier chargement page');

})();
